import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { OpenModalHookType } from '@hooks/useOpenModal';
import Authorization from '@components/Utilities/Authorization';

// ============================================================================
// Confirmación del CONTEO FÍSICO (F5 ②, rediseñado 2026-08-19 a pedido del negocio).
//
// El conteo reescribe el saldo de la sucursal y queda como checkpoint del rebuild:
// no es una edición cualquiera, así que se pide **autorización con PIN** antes de
// guardar — mismo criterio que cerrar caja.
//
// Igual que el corte ciego, aquí NO se muestra lo que el sistema creía tener: ver
// el esperado invita a "cuadrar" en vez de contar. La diferencia se informa DESPUÉS.
// ============================================================================

interface ModalConfirmCountProps {
    modal: OpenModalHookType;
    /** Cuántos insumos se capturaron (los vacíos no se tocan). */
    count: number;
    onConfirm: () => void;
}

export const ModalConfirmCount: React.FunctionComponent<ModalConfirmCountProps> = ({ modal, count, onConfirm }) => {
    const [isAuthorized, setIsAuthorized] = useState(false);

    const onClose = () => {
        setIsAuthorized(false);
        modal.close();
    };

    return (
        <Dialog open={modal.modalOpen} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>
                <Typography variant="h6" fontWeight={600}>
                    Guardar conteo físico
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Alert severity="warning">
                        Vas a fijar el inventario de <strong>{count} insumo(s)</strong> a lo que contaste. Los que
                        dejaste vacíos no se tocan.
                    </Alert>
                    <Typography variant="body2" color="text.secondary">
                        El conteo queda registrado con tu nombre y es el punto de partida desde el que el sistema
                        calcula el inventario. Confirma con tu PIN.
                    </Typography>
                    <Authorization onAuthorized={() => setIsAuthorized(true)} onUnauthorized={() => setIsAuthorized(false)} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack width="100%" direction="row" spacing={1} justifyContent="flex-end">
                    <Button color="inherit" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!isAuthorized || count === 0}
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        Guardar conteo
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
